import {
    MessageTooltip,
    pxToRem,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import React from 'react';

interface HoverActionArticleProps {
    label: string;
    action: JSX.Element;
    disabled?: boolean;
}

export const HoverActionArticle = ({
    label,
    action,
    disabled = false,
}: HoverActionArticleProps) => {
    const [tooltipEnabled, setTooltipEnabled] = React.useState(false);
    const { mobile: isMobile } = useAppDisplayModeContext();

    if (isMobile) {
        return action;
    }

    //todo remove conditional content render when ssr issue with northstar Tooltip has been resolved
    return (
        <MessageTooltip
            trigger={
                <span
                    onMouseEnter={() => setTooltipEnabled(true)}
                    onMouseLeave={() => setTooltipEnabled(false)}
                    style={disabled ? { pointerEvents: 'none' } : undefined}
                >
                    {action}
                </span>
            }
            content={
                tooltipEnabled
                    ? {
                          children: label,
                          size: 16,
                          padding: 16,
                          variables: { maxWidth: pxToRem(220) },
                      }
                    : null
            }
            position="below"
            offset={[-1, 12]}
        />
    );
};
